const callWithRetry = async (fn, backoffStrategy) => {
    try {
        return await fn();
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Network request failed:", e);

        if (e && e.status && !Number.isNaN(Number(e.status)) && Number(e.status) < 500) {
            throw e;
        }

        // eslint-disable-next-line no-console
        console.warn("Retrying request...");
        await backoffStrategy.next(e);
        return callWithRetry(fn, backoffStrategy);
    }
};

export default callWithRetry;
